import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useSignedInContext } from '../../context/AuthContextProvider';
import { ContentWrapper } from '../../components/Wrappers/Wrappers';
import { Text, Title } from '../../components/units/Text';
import { hasPermission } from '../../roles/roles';
import { ServiceInfo } from '../../components/Accumulator/ServiceInfo';
import { RestApiState } from '../../components/Rest/Organization';
import { approveCommissionData } from '../../components/Rest/Commission';
import Alert from '../../components/units/Alerts';
import { FlexWrapper } from '../../components/Wrappers/Wrappers';
import { useNavigate } from "react-router-dom";


import { CommisionProps } from '../../components/Rest/accumulator/interfaces/commission';
import { fetchCommissionData } from '../../components/Rest/accumulator/components/fetchCommissionData';


interface CommissionViewProps {
    data: CommisionProps | null;
}

interface AcbViewProps {
    commission: CommissionViewProps
    alertState: boolean;
    requestState: RestApiState;
}


const defaultState: AcbViewProps = {commission: {data: null}, alertState: false , requestState: RestApiState.Idle}

export const CommissionReview = () => {
    const { serial_number } = useParams()    
    const { user } = useSignedInContext()
    const [props, setProps] = useState(defaultState)
    const navigate = useNavigate();


    const handleAlert = (value: boolean) => {
        setProps(prev => ({
            ...prev,
            alertState: value
        }));
    } 

    const handleRestState = (value: RestApiState) => {
        setProps(prev => ({
            ...prev,
            requestState: value
        }));
    } 

    const statusText = ():string => {
        let text = ''
        switch(props.requestState) {
            case RestApiState.Idle : text = "" ; break;
            case RestApiState.Pending : text = "Обновляется"; break;
            case RestApiState.Success : text = "Обновлено"; break;
            case RestApiState.BadRequest : text = "Заполните поля"; break;
            case RestApiState.ServerError : text = "Ошибка сервера"; break;
            case RestApiState.Unknown : text = "Неизвестная ошибка"; break;
            default: text = "..."; break;
        }
        return text
    }

    function submitClassHandler(status: RestApiState): string {
        // Defines css class based on status
        if (status === RestApiState.Success) {
            return "submit-btn-success"
        }
    
        if (status !== RestApiState.Idle)  {
            return 'submit-btn disabled'
        }
    
        return "bg-secondary text-light"
    }

    if (!serial_number) {
        throw new Error("Serial number must be defined")
    }
    const setCommissionData = (newData: typeof props.commission.data): void => {
        setProps(prev => ({
            ...prev,
            commission: {
              ...prev.commission,
              data: newData,
            },
        }));
    }

    useEffect(() => {
        const fetchSectionData = async () => {
            fetchCommissionData(serial_number, user.role_slug, setCommissionData)
        }
        fetchSectionData()
    }, [])

    const approveCommission = async () => {
        approveCommissionData(serial_number, user.role_slug, handleRestState)
    }
    
    useEffect(() => {
        if (props.requestState === RestApiState.Success) {
            navigate(`/react/acb/detail/${serial_number}`)
        }
    }, [props.requestState])

    return (
        <ContentWrapper>
            <Title>{serial_number}</Title>
            <br />
            <Text className='bold'>⚠️Перед вводом в эскплуатацию убедитесь что все данные заполнены корректно!⚠️</Text>
            <br />
            {hasPermission({role:user.role, resource:'Commission', action:'view'}) && ServiceInfo(serial_number, props.commission)}
            
            <br />
            <br />
            <button 
                    type="submit"
                    disabled={ props.requestState !== RestApiState.Idle }
                    className={ submitClassHandler(props.requestState) }
                    style={{position:'relative', width: '100%', height: '36px', borderRadius: '5px', outline:'none', border: 'none'}}
                    onClick={(e) => handleAlert(true)}
                    >
                    Ввести в эскплуатацию
                </button>
                <Alert alertState={props.alertState} alertHandler={handleAlert} alertTitle='Ввести в эскплуатацию'>

                        <Text>Вы уверенны что готовы ввести АКБ в эскплуатацию?</Text>
                        <br />
                        <FlexWrapper justifyContent='space-between'>
                            <button 
                                type="submit"
                                disabled={ props.requestState !== RestApiState.Idle }
                                className={ submitClassHandler(props.requestState) + ' bg-success' }
                                style={{position:'relative', height: '36px', width: '100%', borderRadius: '5px', outline:'none', border: 'none'}}
                                onClick={(e) => approveCommission()}
                                >
                                { props.requestState === RestApiState.Idle && <Text  className="slide-bottom-to-top">Да</Text>  }
                                { props.requestState === RestApiState.Pending && <Text className="slide-bottom-to-top">{ <div className="btnloader"></div> }</Text>}
                                { (props.requestState !== RestApiState.Pending && props.requestState !== RestApiState.Idle) && <Text className="slide-bottom-to-top">{ statusText() }</Text>} 
                            </button>
                            <button 
                                type="submit"
                                className='bg-danger' 
                                style={{position:'relative', height: '36px', width: '100%', borderRadius: '5px', outline:'none', border: 'none'}}
                                onClick={(e) => handleAlert(false)}
                                >
                                Закрыть
                            </button>
                        </FlexWrapper>
                </Alert>
        </ContentWrapper>
    )
}